import { Avatar, Skeleton, Typography } from "antd";
import { useQuery } from "react-query";

import { Subheader } from ".";

import { Flex } from "~/src/components/flex";
import * as Companies from "~/src/lib/api/companies";
import { Id } from "~/src/lib/api/id";
import * as Jobs from "~/src/lib/api/jobs";
import { getDefaultPage } from "~/src/lib/api/pages";

type JobHeaderProps = {
  jobId: Id | undefined;
};

export const JobHeader = ({ jobId }: JobHeaderProps) => {
  const { data: { data: job } = {} } = useQuery(
    Jobs.getQueryKey({ id: jobId }),
    () => Jobs.get({ id: jobId }),
    { enabled: Boolean(jobId) },
  );

  const { data: { data: company } = {} } = useQuery(
    Companies.getQueryKey({ id: job?.companyId }),
    () => Companies.get({ id: job?.companyId }),
    { enabled: Boolean(job) },
  );

  const page = getDefaultPage(company);

  if (!job || !company) {
    return (
      <Subheader>
        <Flex align="center" justify="space-between" gap="sm">
          <Skeleton.Button key={0} active style={{ width: "24ch" }} />
          <Skeleton.Avatar key={1} active size={50} shape="square" />
        </Flex>
      </Subheader>
    );
  }

  return (
    <Subheader>
      <Flex align="center" justify="space-between" gap="sm">
        <Flex.Item
          key={0}
          style={{ minWidth: 0 /* Allow text truncation with ellipsis. */ }}
        >
          <Typography.Title
            level={4}
            style={{ marginBottom: 0 }}
            ellipsis={true}
          >
            {job.name}
          </Typography.Title>
          <Typography.Text type="secondary" ellipsis={true}>
            {company?.name}
          </Typography.Text>
        </Flex.Item>
        <Avatar key={1} shape="square" size={50} src={page?.logo?.url}>
          {company.name[0]}
        </Avatar>
      </Flex>
    </Subheader>
  );
};
